import {observable, computed, action, makeObservable} from 'mobx';

import Moment from 'moment';
import WatsonApi from '../backends/WatsonApi';

export default class CalendarStore {
    calendars = {};
    calendarIds = new Map();

    constructor() {
        makeObservable(this, {
            calendarIds: observable,
            eventSources: computed,
            addCalendar: action,
            fetchCalendarEvents: action,
        });
    }

    get eventSources() {
        const sources = [];
        let cal;
        this.calendarIds.forEach((value, id) => {
            cal = this.calendars[id];
            sources.push({
                id: cal.id,
                events: cal.events,
                textColor: cal.color,
                color: '#eee',
            });
        });

        return sources;
    };

    addCalendar(calendarObj) {
        console.log('adding calendar: ', calendarObj.id);
        this.calendars[calendarObj.id] = calendarObj;
        this.calendarIds.set(calendarObj.id, true);
    }

    fetchCalendarEvents(calendarId) {
        const store = this,
            startDate = Moment().startOf('month').format('YYYY-MM-DD'),
            endDate = Moment().endOf('month').format('YYYY-MM-DD');

        WatsonApi().then(function (client) {
            client.apis.organization.getItemsById({
                type: 'calendar',
                id: calendarId,
                filter: [startDate, endDate],
            }).then(function (org) {
                if (org.obj !== undefined && org.obj !== null) {
                    store.addCalendar(org.obj);
                }
            });
        });
    }
}

